import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

const initialState = {
  selectedUser: [],
  loadingDepostit: false,
};

export const useDepositStore = create(
  persist(
    immer((set, get) => ({
      ...initialState,
      setLoadingDeposit: (loading) =>
        set((state) => {
          state.loadingDepostit = loading;
        }),

      setSelectedUser: (user) =>
        set((state) => {
          state.selectedUser = user;
        }),
    })),
    {
      name: '@footab/admin/deposits',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
